
    <ml-logo-card>
      <div class="padding-bottom-16">
        <div class="mat-headline">
          {{ 'page not found' | translate | sentancecase }}
        </div>
        <button mat-raised-button (click)="goBackToApp()" color="accent">
          {{ 'go back to the app' | translate | uppercase }}
        </button>
      </div>
    </ml-logo-card>
  